export class SubmitOrderBasicInformations {
    authtoken?: string | null;
    usertype: string;
    firstname?: string;
    lastname?: string;
    emailaddress?: string;
    contactnumber?: number;
    guestoptin?: boolean;
}
